import React from 'react';
import SigninHeader from 'Components/Account/SigninHeader'
import Footer from './Footer';
import TermsAndConditions from 'Modals/TermsAndConditions';

function UserAgreement() {
  return (
    <div className='w-full h-full  '>
       <SigninHeader/>

       <div className='p-12'>
    <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
        
        <TermsAndConditions
        />
       </div>
       <Footer/>
    </div>
  )
}

export default UserAgreement
